import { Grid } from '@mui/material';
import CustomTextField from '../formFields/textField';
import CustomSelectField from '../formFields/selectField';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { subOrderSchema } from 'src/config/yup';
import { t } from 'i18next';
import { showDateFromString, showErrorTost, showSuccessTost, subOrderStatusArray } from 'src/constants';
import LoaderButton from '../loaderButton/loaderButton';
import { useState } from 'react';
import { UPDATE_SUBORDER } from 'src/apiService/apiDeclaration';

const EditSubOrderForm = ({ order, onSuccess, isSuccessfull, onUpdateOrder }) => {
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { isValid, isDirty, errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(subOrderSchema),
    defaultValues: {
      ...order,
      status: order.status[order.status.length - 1].status,
      deliveryDate: showDateFromString(order.deliveryDate),
      perCubicMeterConcretePrice: order.perCubicMeterConcretePrice || (isSuccessfull ? null : 1),
    },
  });

  const updateSubOrder = async (body) => {
    setLoading(true);

    // Check if status has changed
    const currentStatus = order.status[order.status.length - 1].status;
    const newStatus = body.status;

    if (currentStatus === newStatus) {
      // Status hasn't changed, remove status from body
      delete body.status;
    }

    if (!isSuccessfull) {
      delete body.perCubicMeterConcretePrice;
    }

    // Check if volumeOfConcrete or perCubicMeterConcretePrice has changed
    const volumeChanged = body.volumeOfConcrete !== order.volumeOfConcrete;
    const priceChanged = isSuccessfull && body.perCubicMeterConcretePrice !== order.perCubicMeterConcretePrice;

    body = {
      ...body,
      deliveryDate: new Date(body.deliveryDate).toISOString(),
      priceChanged: volumeChanged || priceChanged,
    };

    try {
      const resp = await UPDATE_SUBORDER(order._id, body);
      showSuccessTost(resp.message);
    } catch (error) {
      showErrorTost(error);
    } finally {
      setLoading(false);
      onSuccess();
      onUpdateOrder();
    }
  };

  return (
    <form onSubmit={handleSubmit(updateSubOrder)}>
      <Grid container spacing={2} xs={12}>
        <Grid item xs={12} sm={6}>
          <CustomSelectField
            label={t('orderDetailsPage.subOrderStatus')}
            optionsArray={subOrderStatusArray.slice(2)}
            controller={{
              name: 'status',
              control: control,
              errors: errors.status,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('customerPage.dosage')}
            controller={{
              name: 'dosage',
              control: control,
              errors: errors.dosage,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('customerPage.volumeOfConcrete')}
            type="number"
            controller={{
              name: 'volumeOfConcrete',
              control: control,
              errors: errors.volumeOfConcrete,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('customerPage.deliveryDate')}
            type="date"
            allowPastDates={true}
            controller={{
              name: 'deliveryDate',
              control: control,
              errors: errors.deliveryDate,
              defaultValue: showDateFromString(order.deliveryDate),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.stAddress')}
            type="name"
            controller={{
              name: 'streetAddress',
              control: control,
              errors: errors.streetAddress,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.stNo')}
            type="name"
            controller={{
              name: 'streetNumber',
              control: control,
              errors: errors.streetNumber,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.municipality')}
            type="name"
            controller={{
              name: 'municipality',
              control: control,
              errors: errors.municipality,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('common.city')}
            type="name"
            controller={{
              name: 'city',
              control: control,
              errors: errors.city,
            }}
          />
        </Grid>
        {isSuccessfull && (
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('customerPage.concretePrice(pcm)')}
              type="number"
              controller={{
                name: 'perCubicMeterConcretePrice',
                control: control,
                errors: errors.perCubicMeterConcretePrice,
                // disabled: true,
              }}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Grid item sm={6} xs={12} sx={{ ml: 'auto' }}>
            <LoaderButton
              buttonText={t('menu.editItem')}
              type="submit"
              disabled={!isValid || !isDirty}
              loading={loading}
            />
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default EditSubOrderForm;
